<template>
    <div v-html="content" :style="{ '--list-style': listStyle }" />
</template>

<script setup>
import { computed } from 'vue';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

const props = defineProps({
    content: String,
    listStyle: {
        type: String,
        default: "'- '",
    },
    wrapParagraphs: {
        type: Boolean,
        default: true,
    },
});

// Configure marked to use breaks
marked.use({
    breaks: true,
});

const content = computed(() => {
    const src = props.content ?? '';
    const html = props.wrapParagraphs ? marked.parse(src) : marked.parseInline(src);
    return DOMPurify.sanitize(html);
});
</script>
<style scoped>
:deep(ul, ol) {
    padding-left: 1rem;
}
:deep(li) {
    list-style-type: var(--list-style);
}
</style>
